import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://backend.gatewayfinacial.com/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

export const submitContactForm = async (data) => {
  try {
    const response = await apiClient.post('/contact-us', data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Something went wrong');
  }
};

export const joinUs = async (data) => {
  try {
    const response = await apiClient.post('/join-us', data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Something went wrong');
  }
};

export const getSeoData = async (slug) => {
  try {
    const response = await apiClient.get(`/${slug}`);
    return response.data;
  } catch (error) {
    return { status: false, data: null };
  }
};


export default apiClient;
